module.exports = __webpack_public_path__ + "img/t-martel.57512e81.png";